<div class="fp-bar">
    <label class="fp-search" *ngIf="quickSearchFilter">
        <i class="pi pi-search"></i>
        <input type="search" [placeholder]="quickSearchPlaceholder" [(ngModel)]="quickSearchFilter.value"
            (keydown.enter)="onQuickSearch()" />
        <button *ngIf="quickSearchFilter.value" type="button" class="fp-x" aria-label="Borrar búsqueda"
            (click)="clearQuickSearch()"><i class="pi pi-times"></i></button>
    </label>

    <div class="fp-chips">
        <div class="fp-chip" *ngFor="let f of shownFields" [id]="chipId(f)" [class.is-set]="isSet(f)"
            [class.is-editing]="editing === f" role="button" tabindex="0"
            (click)="onChipClick(f, chip)" (keydown.enter)="onChipClick(f, chip)" #chip>
            <ng-container *ngIf="isSet(f); else emptyChip">
                <ng-container *ngIf="f.type === 'bool'; else valueChip">
                    <i class="pi pi-check"></i>
                    <b class="fp-chip-value">{{ f.label }}</b>
                </ng-container>
                <ng-template #valueChip>
                    <span class="fp-chip-label">{{ f.label }}:</span>
                    <b class="fp-chip-value">{{ chipValue(f) }}</b>
                </ng-template>
                <button type="button" class="fp-x" [attr.aria-label]="'Quitar filtro ' + f.label"
                    (click)="$event.stopPropagation(); clearField(f)"><i class="pi pi-times"></i></button>
            </ng-container>
            <ng-template #emptyChip>
                <i class="pi pi-plus"></i>{{ f.label }}
                <button *ngIf="!f.base" type="button" class="fp-x" [attr.aria-label]="'Quitar filtro ' + f.label"
                    (click)="$event.stopPropagation(); clearField(f)"><i class="pi pi-times"></i></button>
            </ng-template>
        </div>
    </div>

    <button type="button" class="fp-more" *ngIf="menuFields.length || menuSearch" (click)="moreMenu.toggle($event)">
        <i class="pi pi-filter"></i>Más filtros
        <span class="fp-count" *ngIf="extraCount">{{ extraCount }}</span>
    </button>
</div>

<p-overlayPanel #editor styleClass="fp-editor" (onShow)="onEditorShow()" (onHide)="onEditorHide()">
    <ng-template pTemplate="content">
        <div class="fp-editor-body" *ngIf="editing as f" (keydown.escape)="cancelEdit()">
            <div class="fp-editor-title">{{ f.label }}</div>

            <input *ngIf="f.type === 'text'" pInputText [placeholder]="f.placeholder || 'Escribe para filtrar…'"
                [(ngModel)]="f.filter.value" (keydown.enter)="confirmEdit()" />

            <p-listbox *ngIf="f.type === 'select' || f.type === 'multiselect'" [options]="f.options ?? []"
                optionLabel="label" optionValue="value" [multiple]="f.type === 'multiselect'"
                [checkbox]="f.type === 'multiselect'" [filter]="f.type === 'multiselect' || !!f.filterable"
                filterPlaceHolder="Buscar…" scrollHeight="240px" [(ngModel)]="f.filter.value"
                [virtualScroll]="(f.options?.length ?? 0) > 200" [virtualScrollItemSize]="36"
                (onChange)="onSelectChange()"></p-listbox>

            <div class="fp-range" *ngIf="f.type === 'date'">
                <label>Desde</label>
                <p-calendar [firstDayOfWeek]="1" [showIcon]="true" dateFormat="dd/mm/yy" panelStyleClass="fp-calendar-panel" [(ngModel)]="f.filter.value"></p-calendar>
                <ng-container *ngIf="f.filterTo">
                    <label>Hasta</label>
                    <p-calendar [firstDayOfWeek]="1" [showIcon]="true" dateFormat="dd/mm/yy" panelStyleClass="fp-calendar-panel" [(ngModel)]="f.filterTo.value"></p-calendar>
                </ng-container>
            </div>

            <div class="fp-range" *ngIf="f.type === 'number'">
                <label>Mín.</label>
                <p-inputNumber [mode]="f.mode || 'decimal'" [minFractionDigits]="f.minFractionDigits"
                    [maxFractionDigits]="f.maxFractionDigits" [suffix]="f.suffix || ''" [(ngModel)]="f.filter.value"
                    (keydown.enter)="confirmEdit()"></p-inputNumber>
                <ng-container *ngIf="f.filterTo">
                    <label>Máx.</label>
                    <p-inputNumber [mode]="f.mode || 'decimal'" [minFractionDigits]="f.minFractionDigits"
                        [maxFractionDigits]="f.maxFractionDigits" [suffix]="f.suffix || ''" [(ngModel)]="f.filterTo.value"
                        (keydown.enter)="confirmEdit()"></p-inputNumber>
                </ng-container>
            </div>

            <div class="fp-editor-actions">
                <button type="button" class="fp-btn" (click)="clearField(f); confirmEdit()">Quitar</button>
                <button type="button" class="fp-btn primary" (click)="confirmEdit()">Aplicar</button>
            </div>
        </div>
    </ng-template>
</p-overlayPanel>

<p-overlayPanel #moreMenu styleClass="fp-menu">
    <ng-template pTemplate="content">
        <div class="fp-menu-head">Filtrar también por</div>
        <input class="fp-menu-search" pInputText placeholder="Buscar filtro…" [(ngModel)]="menuSearch" />
        <div class="fp-menu-list">
            <label class="fp-menu-item" *ngFor="let f of menuFields">
                <input type="checkbox" [checked]="isShown(f)" (change)="toggleExtra(f, $any($event.target).checked)" />
                {{ f.label }}
            </label>
        </div>
    </ng-template>
</p-overlayPanel>
